<i class="fa-heart favourite-icon" [ngClass]="isFavourite ? 'fas' : 'far'"></i>
